import { render, staticRenderFns } from "./GoogleDocument.vue?vue&type=template&id=0fe375f4&"
import script from "./GoogleDocument.vue?vue&type=script&lang=js&"
export * from "./GoogleDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports